import { FC, ReactNode, useEffect, useState } from "react";
import { SocketContext } from "./SocketContext";
import { OverlaySocket } from "@ailenax-overlay/shared";
import { io } from "socket.io-client";
import { useAuth } from "@/hooks/useAuth";
import customParser from "socket.io-msgpack-parser";
import { useNavigate } from "react-router-dom";

export const WebSocketProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const { token } = useAuth();
    const navigate = useNavigate();
    const [socket, setSocket] = useState<OverlaySocket | null>(null);

    useEffect(() => {
        if (token === null) {
            navigate("/login");
            return;
        }
        
        const newSocket = io(import.meta.env.VITE_OVERLAY_URL, {
            parser: customParser,
            auth: {
                token
            }
        });

        newSocket.on("connect_error", (e) => {
            if (e.message === "Authentication error") {
                navigate("/login");
            }
        })
        
        newSocket.on("reload-overlay", () => {
            window.location.reload();
        });

        setSocket(newSocket);

        return () => {
            newSocket.disconnect();
        }
    }, [token, navigate]);

    return socket === null ? null : <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
}